(() => {
  if (window.__CA_MEGA_INJECTED__) return;
  window.__CA_MEGA_INJECTED__ = true;
  if (window.matchMedia && !window.matchMedia("(min-width: 990px)").matches) return;

  const menu = window.CA_MEGA_MENU || [];
  const images = window.CA_MEGA_IMAGES || {};
  const short = window.CA_MEGA_SHORT || {};
  const assetBase = (window.CA_MEGA_ASSET_BASE != null
    ? window.CA_MEGA_ASSET_BASE
    : (typeof location !== "undefined" ? (location.origin + "/") : "/"));
  const composites = Object.assign({}, window.CA_MEGA_COMPOSITES || {});


  const label = (t) => short[t] || t;
  const DESKTOP_ONLY = true;

  document.documentElement.classList.add("ca-mega-hide-native");


  const root = document.createElement("div");
  root.className = "ca-mega-root";
  root.innerHTML = `<div class="ca-mega-backdrop" style="position:absolute;inset:0"></div><div class="ca-mega-panels"></div>`;
  document.body.appendChild(root);
  const panelsEl = root.querySelector(".ca-mega-panels");
  const backdrop = root.querySelector(".ca-mega-backdrop");

  function groups(panel) {
    return panel.flat
      ? [panel.columns, panel.columns2, panel.columns3].filter(Boolean)
      : (panel.columns || []).map((col) => (col.stack ? col.stack : [col]));
  }
  function absUrl(url) {
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith("//")) return "https:" + url;
    try { return new URL(url, "https://lucialiving.ca/").href; } catch { return url; }
  }
  function link(node, cls) {
    const text = label(node.title);
    if (!node.url) return `<span class="${cls}">${text}</span>`;
    return `<a class="${cls}" href="${absUrl(node.url)}">${text}</a>`;
  }
  function list(node) {
    const kids = (node.children || []).map((c) => `<li>${link(c, "")}</li>`).join("");
    return `<div class="group">${link(node, "l2")}${kids ? `<ul class="l3">${kids}</ul>` : ""}</div>`;
  }
  function tile(node, combo) {
    const src = (combo ? (composites[node.handle] || images[node.handle]) : images[node.handle]);
    const loading = combo ? "eager" : "lazy";
    return `<a class="tile${combo ? " combo" : ""}" href="${absUrl(node.url)}"><span class="frame"><img alt="" loading="${loading}" decoding="async" src="${src || ""}"></span><span class="cap">${label(node.title)}</span></a>`;
  }
  function column(nodes) {
    return `<div class="col">${nodes.map(list).join("")}</div>`;
  }
  function lighting(panel) {
    const cols = groups(panel);
    const extras = cols[3] || [];
    const lamps = extras.filter((n) => ["Table Lamp", "Floor Lamp", "Chandelier"].includes(n.title));
    // Trends / Shop all lighting intentionally omitted — top nav already covers entry
    const peerLinks = lamps.map((n) => link(n, "")).join("");
    return `<div class="cols c4">
      ${column([cols[0][0]])}
      ${column([cols[1][0]])}
      ${column([cols[2][0]])}
      <div class="col"><div class="peers">${peerLinks}</div></div>
    </div>`;
  }
  function material(panel) {
    const cols = groups(panel);
    const stack = cols[3] || [];
    const metal = stack.filter((n) => n.title === "Metal Light");
    const tiles = stack.filter((n) => n.title !== "Metal Light");
    return `<div class="cols c4">
      ${column(cols[0])}
      ${column(cols[1])}
      ${column(cols[2])}
      ${column(metal)}
    </div>
    <div class="tiles n5">${tiles.map((n) => tile(n)).join("")}</div>`;
  }
  function style(panel) {
    const cols = groups(panel);
    return `<div class="cols c4">${cols.map(column).join("")}</div>`;
  }
  function series(panel) {
    const cols = groups(panel);
    const tiles = cols[3] || [];
    return `<div class="cols c3">
      ${column(cols[0])}
      ${column(cols[1])}
      ${column(cols[2])}
    </div>
    <div class="tiles n4">${tiles.map((n) => tile(n, true)).join("")}</div>`;
  }
  function rooms(panel) {
    const links = groups(panel).flat().map((n) => link(n, "")).join("");
    return `<div class="room-grid">${links}</div>`;
  }
  function help(panel) {
    const rows = (panel.columns || []).map((n) => {
      const text = label(n.title);
      if (!n.url) return `<li><span>${text}</span></li>`;
      return `<li><a href="${absUrl(n.url)}">${text}</a></li>`;
    }).join("");
    return `<ul class="help-list">${rows}</ul>`;
  }

  const builders = {
    "All Lighting": lighting,
    Material: material,
    Style: style,
    "Our Series": series,
    Room: rooms,
    "Help & Support": help
  };
  const kinds = {
    "All Lighting": "wide",
    Material: "wide",
    Style: "wide",
    "Our Series": "wide",
    Room: "rooms",
    "Help & Support": "narrow"
  };

  const panelMap = {};
  menu.forEach((panel) => {
    if (panel.direct || !builders[panel.title]) return;
    const el = document.createElement("div");
    el.className = `ca-mega-sheet ${kinds[panel.title] || ""}`;
    el.dataset.panel = panel.title;
    el.innerHTML = builders[panel.title](panel);
    panelsEl.appendChild(el);
    panelMap[panel.title] = el;
  });

  function headerBottom() {
    const sticky = document.querySelector("#sticky-header") || document.querySelector(".header-middle") || document.querySelector("#page-header");
    if (!sticky) return 80;
    const r = sticky.getBoundingClientRect();
    return Math.max(64, Math.round(r.bottom));
  }

  function place(title) {
    const el = panelMap[title];
    if (!el) return;
    const top = headerBottom() + 8;
    el.style.top = top + "px";
    const vw = window.innerWidth;
    if (el.classList.contains("rooms")) {
      const width = Math.min(980, vw - 96);
      el.style.width = width + "px";
      el.style.left = Math.max(48, (vw - width) / 2) + "px";
      el.style.right = "auto";
      return;
    }
    if (el.classList.contains("narrow")) {
      const item = findNavItem(title);
      const width = 280;
      let left = 16;
      if (item) {
        const box = item.getBoundingClientRect();
        // Prefer align under trigger; keep fully on-screen
        left = box.left;
        left = Math.max(16, Math.min(left, vw - width - 16));
      }
      el.style.width = width + "px";
      el.style.left = left + "px";
      el.style.right = "auto";
      return;
    }
    // wide panels: align near left of nav cluster, with breathing room
    const nav = document.querySelector("nav.main-nav");
    const navBox = nav?.getBoundingClientRect();
    const width = Math.min(el.classList.contains("wide") ? 1040 : 860, vw - 96);
    let left = navBox ? navBox.left : 72;
    left = Math.max(48, Math.min(left, vw - width - 48));
    // All Lighting can sit a bit left under logo/nav start
    if (title === "All Lighting") left = Math.max(48, Math.min((navBox?.left || 72) - 20, vw - width - 48));
    el.style.width = width + "px";
    el.style.left = left + "px";
    el.style.right = "auto";
  }

  function findNavItem(title) {
    const links = [...document.querySelectorAll("nav.main-nav li.level0 > a.relative")];
    return links.find((a) => (a.getAttribute("arial-label") || a.textContent || "").replace(/\s+/g, " ").trim() === title)?.closest("li.level0");
  }

  let active = null;
  let closeTimer = null;

  function open(title) {
    if (!panelMap[title]) return;
    clearTimeout(closeTimer);
    active = title;
    Object.entries(panelMap).forEach(([k, el]) => el.classList.toggle("show", k === title));
    document.querySelectorAll("nav.main-nav li.level0").forEach((li) => {
      const t = (li.querySelector(":scope > a.relative")?.getAttribute("arial-label") || li.querySelector(":scope > a.relative")?.textContent || "").replace(/\s+/g, " ").trim();
      li.classList.toggle("ca-mega-active", t === title);
    });
    place(title);
  }
  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      active = null;
      Object.values(panelMap).forEach((el) => el.classList.remove("show"));
      document.querySelectorAll("nav.main-nav li.level0").forEach((li) => li.classList.remove("ca-mega-active"));
    }, 160);
  }

  // bind top-level items
  const titles = Object.keys(panelMap);
  titles.forEach((title) => {
    const li = findNavItem(title);
    if (!li) return;
    const a = li.querySelector(":scope > a.relative");
    // preview only: stay on this page when clicking dropdown roots
    if (a) {
      a.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        open(title);
      });
    }
    li.addEventListener("mouseenter", () => open(title));
    li.addEventListener("focusin", () => open(title));
    li.addEventListener("mouseleave", scheduleClose);
  });
  Object.values(panelMap).forEach((el) => {
    el.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
    });
    el.addEventListener("mouseleave", scheduleClose);
  });
  backdrop.addEventListener("click", () => {
    active = null;
    Object.values(panelMap).forEach((el) => el.classList.remove("show"));
  });
  window.addEventListener("resize", () => {
    if (active) place(active);
  });

  // default open All Lighting briefly so preview is obvious
  setTimeout(() => open("All Lighting"), 400);
})();
